module.exports = __webpack_public_path__ + "img/ChatCenteredDots.607a60dd.svg";